{
  "title": "Dashboard",
  "actions": {
    "join_team": "Join Team",
    "join_team_description": "Join a team by finding an existing team and requesting to join.",
    "new_team": "New Team",
    "new_team_description": "Start a new teaching team with your own profile.",

    "timetable": "Timetable"
  },
  "invitations": {
    "label": "Invitations",
    "respond": "Respond"
  },
  "listing_profiles": {
    "label": "Listing Profiles",
    "empty_list": "No listings yet. Join or start a team to view its listing here.",
    "listing_type.team": "Team Listing",
    "listing_type.personal": "Personal Listing",
    "card_actions": {
      "profile": "Edit Profile",
      "manage_specialities": "Manage Specialities",
      "classes": "Create Class",
      "measurement_and_feedback": "Measurement and Feedback"
    }
  },
  "class_listings": {
    "label": "Class Listings",
    "empty_list": "No classes. Click the list class button to list your first class.",
    "custom_class_card": {
      "actions": {
        "edit_details": "Edit Details",
        "set_availability": "Set Availability"
      },
      "actions_menu": "Actions",
      "num_offered_one": "{{count}} class offered",
      "num_offered_other": "{{count}} classes offered",
      "availability": "Availability",
      "hours_per_week": "{{hours}} hours per week"
    }
  }
}
